import { usePersonMention } from "@/modules/common/entities/person/mention/utils/use-person-mention";
import { GATEWAY_PATH } from "@/modules/gateway/pages";
import { GatewayActions } from "gql/graphql";
import { generatePath } from "react-router-dom";

export function useWysiwygMention() {
  const { mentionOptions } = usePersonMention();

  const suggestions = mentionOptions.map((option) => {
    const path = generatePath(GATEWAY_PATH, {
      action: GatewayActions.OpenPerson,
    });

    return {
      text: option.label,
      value: option.label,
      url: `${window.location.origin}${path}?id=${option.value}`,
    };
  });

  return {
    separator: " ",
    trigger: "@",
    suggestions,
  };
}
